import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { staffLogin } from "@/lib/api";

const HubLogin = () => {
    const [pin, setPin] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const nextPath = searchParams.get("next") || "/hub";

    const submit = async (e) => {
        e?.preventDefault();
        if (pin.length < 4) {
            setError("PIN must be at least 4 digits");
            return;
        }
        setSubmitting(true);
        setError("");
        try {
            const r = await staffLogin(pin);
            localStorage.setItem("naami_staff", JSON.stringify({ name: r.name, token: r.token, role: r.role }));
            navigate(nextPath);
        } catch {
            setError("Invalid PIN. Try again.");
            setPin("");
        } finally {
            setSubmitting(false);
        }
    };

    const tap = (d) => {
        if (pin.length >= 6) return;
        setPin((p) => p + d);
        setError("");
    };
    const back = () => setPin((p) => p.slice(0, -1));

    return (
        <div
            className="min-h-screen bg-[var(--bg)] text-[var(--text)] flex flex-col items-center justify-center px-6"
            data-testid="hub-login-page"
        >
            <Link to="/" className="absolute top-6 left-6 font-mono text-[10px] uppercase tracking-[0.22em] text-muted hover:text-gold">
                ← naami<span className="text-gold">.</span> hub
            </Link>

            <div className="w-full max-w-md">
                <p className="eyebrow text-center justify-center">// Staff Access</p>
                <h1 className="font-display text-[40px] text-center mt-4 mb-2 leading-tight">
                    Enter your <span className="text-gold">PIN.</span>
                </h1>
                <p className="text-muted text-center text-sm mb-10">
                    Demo PIN: <span className="font-mono text-gold">4321</span>
                </p>

                <form onSubmit={submit}>
                    <div className="flex justify-center gap-3 mb-8" data-testid="hub-pin-dots">
                        {[0, 1, 2, 3, 4, 5].map((i) => (
                            <div
                                key={i}
                                className={`w-12 h-14 border ${
                                    i < pin.length
                                        ? "border-[var(--gold)] bg-[var(--gold)]/10"
                                        : "border-[var(--border)]"
                                } grid place-items-center font-mono text-2xl text-gold`}
                            >
                                {i < pin.length ? "●" : ""}
                            </div>
                        ))}
                    </div>

                    <div className="grid grid-cols-3 gap-3 mb-6">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((d) => (
                            <button
                                key={d}
                                type="button"
                                onClick={() => tap(String(d))}
                                className="h-16 border border-[var(--border)] hover:border-[var(--gold)] font-display text-2xl transition-colors"
                                data-testid={`pin-key-${d}`}
                            >
                                {d}
                            </button>
                        ))}
                        <button
                            type="button"
                            onClick={back}
                            className="h-16 border border-[var(--border)] hover:border-[var(--gold)] font-mono text-[10px] uppercase tracking-[0.22em] transition-colors"
                            data-testid="pin-key-back"
                        >
                            Del
                        </button>
                        <button
                            type="button"
                            onClick={() => tap("0")}
                            className="h-16 border border-[var(--border)] hover:border-[var(--gold)] font-display text-2xl transition-colors"
                            data-testid="pin-key-0"
                        >
                            0
                        </button>
                        <button
                            type="submit"
                            disabled={submitting || pin.length < 4}
                            className="h-16 bg-[var(--gold)] text-[var(--bg)] hover:bg-[#F2C24E] disabled:opacity-30 font-mono uppercase text-sm tracking-[0.18em] font-bold"
                            data-testid="pin-submit"
                        >
                            Enter
                        </button>
                    </div>

                    {error && (
                        <p className="text-[#ff5246] text-sm text-center font-mono" data-testid="hub-login-error">
                            {error}
                        </p>
                    )}
                </form>
            </div>
        </div>
    );
};

export default HubLogin;
